import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { FadeIn } from '../components/ui/FadeIn';
export function RefundPolicyPage() {
  return <main className="min-h-screen w-full bg-white selection:bg-neutral-900 selection:text-white pt-24" data-id="element-237">
      <Navbar data-id="element-238" />

      <section className="px-6 py-12 md:py-20" data-id="element-239">
        <div className="max-w-3xl mx-auto" data-id="element-240">
          <FadeIn data-id="element-241">
            <h1 className="text-4xl md:text-5xl font-semibold tracking-tight text-neutral-900 mb-12" data-id="element-242">
              Refund and Cancellation Policy
            </h1>

            <div className="prose prose-neutral prose-lg max-w-none" data-id="element-243">
              <div className="mb-12" data-id="element-244">
                <h2 className="text-2xl font-semibold text-neutral-900 mb-4" data-id="element-245">
                  Refund Policy
                </h2>
                <p className="text-neutral-600 mb-4" data-id="element-246">
                  Due to the custom nature of software development services,
                  refunds are handled as follows:
                </p>
                <ul className="list-disc pl-5 space-y-2 text-neutral-600 mb-4" data-id="element-247">
                  <li data-id="element-248">
                    Payments made for completed and approved milestones are
                    non-refundable.
                  </li>
                  <li data-id="element-249">
                    If a project is cancelled before a milestone begins, any
                    unused portion of funds may be refunded at our discretion.
                  </li>
                  <li data-id="element-250">
                    If we are unable to deliver agreed services, a partial or
                    full refund may be issued.
                  </li>
                </ul>
              </div>

              <div data-id="element-251">
                <h2 className="text-2xl font-semibold text-neutral-900 mb-4" data-id="element-252">
                  Cancellation
                </h2>
                <p className="text-neutral-600" data-id="element-253">
                  Clients may cancel a project at any time. Work completed up to
                  the cancellation date will be billed.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </section>

      <Footer data-id="element-254" />
    </main>;
}